import type { CatalogProduct } from '../types/catalog'

/**
 * Catálogo de productos de Creativo Digital.
 * Para sumar un producto nuevo, duplicá un objeto y cambiá portada,
 * título, descripción y links.
 */
export const catalogProducts: CatalogProduct[] = [
  {
    id: '200-jabones-artesanales',
    title: '200 Jabones Artesanales',
    description:
      'Aprendé a crear jabones artesanales con más de 200 fórmulas y descubrí cómo transformar este conocimiento en un posible emprendimiento.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/58bed775-b6f7-4749-88b4-6156113179fd.jpg',
    coverAlt: 'Portada del ebook 200 Jabones Artesanales',
    links: [
      {
        label: 'Ver producto',
        href: 'https://200jabonesartesanales.creativodigital.shop/',
      },
    ],
  },
  {
    id: '100-new-york-cookies',
    title: '100 New York Cookies',
    description:
      'Recetas, técnicas y herramientas para preparar auténticas New York Cookies y descubrir cómo convertirlas en una oportunidad de negocio.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/e16e3c17-8ed4-44a6-9d8b-63c2df79fb0b.jpg',
    coverAlt: 'Portada del ebook 100 New York Cookies',
    links: [
      {
        label: 'Ver producto',
        href: 'https://100nycookies.creativodigital.shop/',
      },
    ],
  },
  {
    id: '500-recetas-keto',
    title: '500 Recetas Keto',
    description:
      'Más de 500 recetas Keto para desayunos, almuerzos, cenas, postres y mucho más. Una guía práctica para comer rico, variado y sin complicaciones.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/fd187a34-103a-4b6a-ba6c-437e0cb7f6a0.jpg',
    coverAlt: 'Portada del ebook 500 Recetas Keto',
    links: [
      {
        flag: '🇦🇷',
        label: 'Ver en pesos argentinos',
        href: 'https://500recetasketosintacc.creativodigital.shop/',
        srHint: 'versión en pesos argentinos',
      },
      {
        flag: '🌎',
        label: 'Ver en dólares',
        href: 'https://500recetasketosingluten.creativodigital.shop/',
        srHint: 'versión en dólares',
      },
    ],
  },
]
